import * as Sentry from "@sentry/react"

// Get Sentry configuration from meta tags
const sentryDsn = document.querySelector('meta[name="SENTRY_DSN"]')?.getAttribute("content")
const sentryEnvironment = document
  .querySelector('meta[name="SENTRY_ENVIRONMENT"]')
  ?.getAttribute("content")

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: sentryEnvironment || "development",
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.feedbackIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}
